import { useEffect, useState } from 'react';

interface BotDetectionResult {
  isBot: boolean;
  isSuspicious: boolean;
  isReady: boolean;
}

export const useBotProtection = (): BotDetectionResult => {
  const [result, setResult] = useState<BotDetectionResult>({ 
    isBot: false, 
    isSuspicious: false,
    isReady: false 
  });

  useEffect(() => {
    const detectBot = () => {
      const checks = {
        // Selenium, Puppeteer automation tools
        webDriver: navigator.webdriver === true,
        
        // Headless Chrome
        headlessChrome: /HeadlessChrome/.test(navigator.userAgent),
        
        // PhantomJS
        phantom: !!(window as any).callPhantom || !!(window as any)._phantom,
        
        // Training scrapers (should block)
        trainingBot: /CCBot|Bytespider|Diffbot|Meta-ExternalAgent|cohere-ai|ImagesiftBot/i.test(navigator.userAgent),
        
        // Search/citation AI agents (should allow - beneficial for SEO)
        // GPTBot, ClaudeBot, Perplexity, Amazonbot are search-oriented and drive traffic
        
        // Missing language settings (suspicious)
        noLanguages: !navigator.languages || navigator.languages.length === 0,
        
        // Zero viewport dimensions
        suspiciousViewport: window.outerWidth === 0 || window.outerHeight === 0,
      };

      const isBot = checks.webDriver || checks.phantom || checks.trainingBot || checks.headlessChrome;
      const isSuspicious = checks.noLanguages || checks.suspiciousViewport;

      // Delay ready state to timeout crawlers
      setTimeout(() => {
        setResult({
          isBot,
          isSuspicious,
          isReady: true
        });
      }, 1500);
    };

    detectBot();
  }, []);

  return result;
};
